import { Col, Row, Tooltip } from "antd";
import moment from "moment";
import React, { Component } from "react";
import ReactQuill from "react-quill";
import { Collaborationformats, Collaborationmodules } from "./Index";
export default class SingleMessages extends Component {
  constructor(props) {
    super(props);
    let { message } = this.props;
    this.state = {
      style: { display: "none" },
      isEidt: false,
      typingindicator: null,
      chattext: message,
    };
  }
  handleMouseEnter = () => {
    this.setState({
      style: { display: "block" },
    });
  };

  handleMouseLeave = () => {
    this.setState({
      style: { display: "none" },
    });
  };
  render() {
    let { message, createdOn, id, chatThreadClient } = this.props;
    return this.state.isEidt ? (  
      <Row
        span={24}
        style={{
          borderRadius: "10px",
          backgroundColor: "#bdc0d6",
          padding: "10px",
          marginBottom: "5px",
          marginTop: "5px",
          alignItems: "flex-end",
          background: "white",
        }}
      >
        <Col span={24}>
          <ReactQuill
            value={this.state.chattext}
            onChange={(input) => {
              this.setState({
                chattext: input,
              });
            }}
            placeholder={"Text your message"}
            modules={Collaborationmodules}
            formats={Collaborationformats}
          />
          <i style={{ display: "flex", flexDirection: "row-reverse" }}>
            <Tooltip placement="top" title={"Done"}>
              <i
                className="fa fa-check"
                aria-hidden="true"
                style={{
                  color: "#52c41a",
                  fontSize: "20px !important",
                  marginTop: "10px",
                }}
                onClick={() => {
                  this.setState({
                    isEidt: false,
                  });
                  chatThreadClient.updateMessage(id, {
                    content: this.state.chattext,
                  });
                }}
              ></i>
            </Tooltip>
            <Tooltip placement="top" title={"Cancel"}>
              <i
                className="fa fa-times"
                aria-hidden="true"
                style={{
                  color: "#cf1322",
                  fontSize: "20px !important",
                  marginTop: "10px",
                }}
                onClick={() => {
                  this.setState({
                    isEidt: false,
                  });
                }}
              ></i>
            </Tooltip>
          </i>
        </Col>        
      </Row>
    ) : (      
      <div style={{ display: "flex", flexDirection: "row-reverse" }}>        
        <Row
          span={24}
          style={{
            borderRadius: "10px",
            backgroundColor: "#e6e6ff",
            padding: "10px",
            marginBottom: "5px",
            marginTop: "5px",
            width: "fit-content",
            maxWidth: "50%",
            minWidth: "200px",
          }}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <Row span={24}>
            <Col span={18} style={{marginBottom:17}}>
              {moment().diff(moment(createdOn), "hour") <= 12
                ? moment(createdOn).format("LT")
                : moment(createdOn).format("lll")}
            </Col>
            <Col span={6} style={this.state.style}>
              <div style={{ display: 'flex' ,float:'right'}}>
                <div className="float-end">
                  <Tooltip placement="top" title={"Edit"}>
                    <i
                      className="fa fa-pencil"
                      aria-hidden="true"
                      style={{ color: "black" }}
                      onClick={() => {
                        this.setState({
                          isEidt: true,
                        });
                      }}
                    ></i>
                  </Tooltip>
                </div>
                <div >
                  <Tooltip placement="top" title={"Delete"}>
                    <i
                      aria-hidden="true"
                      style={{ color: " #cf1322" }}
                      className="fa fa-trash"
                      onClick={() => {
                        chatThreadClient.deleteMessage(id);
                      }}
                    ></i>{" "}
                  </Tooltip>
                </div></div>
            </Col>
          </Row>
          <div dangerouslySetInnerHTML={{ __html: message }} style={{marginLeft:"1px", overflowWrap: "break-word",marginBottom:"-16px"}}></div>
        </Row>
      </div>
    );
  }
}